import { useNavigate } from "react-router-dom";
import { Building2, Users, LogOut } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const NAVY = "#2a2420";
const ORANGE = "#607840";

export default function OnboardingChoicePage() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: "#fefcf8" }}
    >
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <img src="/login-logo.png" alt="Bill Lens" className="w-12 h-12 rounded-2xl mx-auto mb-4 object-cover" />
          <h1 className="text-2xl font-extrabold" style={{ color: NAVY }}>
            Welcome to Bill Lens
          </h1>
          <p className="text-sm mt-1.5" style={{ color: NAVY, opacity: 0.5 }}>
            {user?.email} · To get started, set up or join a business
          </p>
        </div>

        {/* Options */}
        <div className="space-y-3">
          {/* Create a business */}
          <button
            onClick={() => navigate("/create-business")}
            className="w-full flex items-center gap-4 p-5 rounded-2xl text-left transition-all"
            style={{
              backgroundColor: "#fefcf8",
              border: `1.5px solid ${NAVY}1a`,
              boxShadow: "0 2px 12px rgba(80,55,30,0.06)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.border = `1.5px solid ${ORANGE}55`)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.border = `1.5px solid ${NAVY}1a`)
            }
          >
            <div
              className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${ORANGE}15` }}
            >
              <Building2 size={20} style={{ color: ORANGE }} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-bold" style={{ color: NAVY }}>
                Register a business
              </p>
              <p className="text-xs mt-0.5" style={{ color: NAVY, opacity: 0.5 }}>
                Submit a registration request for admin approval
              </p>
            </div>
          </button>

          {/* Join a business */}
          <button
            onClick={() => navigate("/join-business")}
            className="w-full flex items-center gap-4 p-5 rounded-2xl text-left transition-all"
            style={{
              backgroundColor: "#fefcf8",
              border: `1.5px solid ${NAVY}1a`,
              boxShadow: "0 2px 12px rgba(80,55,30,0.06)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.border = `1.5px solid ${NAVY}44`)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.border = `1.5px solid ${NAVY}1a`)
            }
          >
            <div
              className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${NAVY}0d` }}
            >
              <Users size={20} style={{ color: NAVY, opacity: 0.6 }} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-bold" style={{ color: NAVY }}>
                Join a business
              </p>
              <p className="text-xs mt-0.5" style={{ color: NAVY, opacity: 0.5 }}>
                Use an invitation code or request access
              </p>
            </div>
          </button>
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={handleSignOut}
            className="flex items-center gap-1.5 text-sm mx-auto"
            style={{ color: NAVY, opacity: 0.4 }}
          >
            <LogOut size={13} />
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
